import React from 'react';
import { hooks } from '@lifesize/clients.sdk';
import { connect } from 'react-redux';
import { openInCallModal } from 'actions/InCallModal';
import Header from 'components/Header/Header';
import Modals from 'constants/Modals';

const mapDispatchToProps = (dispatch) => ({
  handleConfirmRemoteModerationEnd: () => {
    dispatch(openInCallModal(Modals.endRemoteModeration));
  }
});

const mapStateToProps = (state, ownProps) => ({
  isCallConnected: ownProps.isCallConnected,
  disabled: ownProps.isRemoteModerationAction
});

const ConnectedComponent = connect(mapStateToProps, mapDispatchToProps)(Header);

const FunctionalWrapper = (props) => {
  const isCallConnected = hooks.useCallConnected();
  const isRemoteModerationAction = hooks.useIsRemoteModerationActive();
  return (
    <ConnectedComponent
      {...props}
      isRemoteModerationAction={isRemoteModerationAction}
      isCallConnected={isCallConnected}
    />
  );
};

export default FunctionalWrapper;
